"use client"

import { useEffect, useState } from "react"
import { PiUserList } from "react-icons/pi"
import { IoDocumentsOutline } from "react-icons/io5"
import { LiaFileInvoiceDollarSolid, LiaCcVisa } from "react-icons/lia"
import DocumentTab from "./DocumentTab"
import InvoiceTab from "./InvoiceTab"
import VisaTab from "./VisaTab"
import ApplicationForm from "./applicationForm"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

export default function Tabs({ propsData, setApplicationSaved, applicationSaved, onRefresh }) {
  const { id: idFromParams } = useParams()
  const newData = useSelector((state) => state.createApplication.newData)
  const [allow, setAllow] = useState(false)
  const [activeTab, setActiveTab] = useState("information")

  const tabs = [
    { key: "information", label: "Information", icon: <PiUserList className="h-5 w-5" /> },
    { key: "documents", label: "Documents", icon: <IoDocumentsOutline className="h-5 w-5" /> },
    { key: "invoice", label: "Invoice", icon: <LiaFileInvoiceDollarSolid className="h-5 w-5" /> },
    { key: "visaStatus", label: "Visa Status", icon: <LiaCcVisa className="h-5 w-5" /> },
  ]

  useEffect(() => {
    if (
      (idFromParams && idFromParams !== "new" && idFromParams !== "") ||
      (newData.id && newData.id !== "new" && newData.id !== "")
    ) {
      setAllow(true)
    }
  }, [idFromParams, newData])

  // Determine if each tab should be enabled
  const isTabEnabled = (tabKey) => {
    if (tabKey === "information") return true
    if (!allow) return false

    if (tabKey === "documents") return true
    if (tabKey === "invoice") {
      const isNotCancelled = propsData.status !== "Cancelled" && propsData.status !== "WithdrawnByClient" && propsData.status !== "WithdrawnByAgent"
      const canAccessInvoice = (propsData.status === "Submitted" || newData.status === "Submitted" || propsData.status === "In-Progress" || propsData.status === "VisaApplied" || propsData.status === "Finalized") && isNotCancelled
      
      return canAccessInvoice
    }
    
    if (tabKey === "visaStatus") return propsData.paymentStatus === "Paid"

    return false
  }

  // Handle tab click with validation
  const handleTabClick = (tabKey) => {
    if (isTabEnabled(tabKey)) {
      setActiveTab(tabKey)
    }
  }

  return (
    <div className="mt-6">
      <div className="flex gap-1">
        {/* Map through the tabs to create buttons */}
        {tabs.map((tab) => (
          <button
            key={tab.key}
            className={`px-5 py-3 text-sm font-medium whitespace-nowrap border border-b-0 rounded-t-xl transition-all duration-300 
              ${activeTab === tab.key ? "bg-[#FFFBF5] border-[#CAC3BB]" : "bg-gray-200 border-transparent"} 
              ${!isTabEnabled(tab.key) ? "opacity-30" : "cursor-pointer"}`}
            onClick={() => handleTabClick(tab.key)}
            disabled={!isTabEnabled(tab.key)}
            title={
              tab.key === "invoice" && propsData.status !== "Submitted"
                ? "Available after application is submitted"
                : tab.key === "visaStatus" && propsData.paymentStatus !== "Paid"
                  ? "Available after payment is completed"
                  : ""
            }
          >
            <span className="hidden">{tab.icon}</span>
            <span className="inline md:hidden">{activeTab === tab.key ? tab.label : tab.icon}</span>
            <span className="hidden md:inline">{tab.label}</span>
          </button>
        ))}
      </div>

      {activeTab === "information" && (
        <ApplicationForm
          propsData={propsData}
          allow={allow}
          setActiveTab={setActiveTab}
          setApplicationSaved={setApplicationSaved}
          applicationSaved={applicationSaved}
          onRefresh={onRefresh}
        />
      )}
      {activeTab === "documents" && allow && <DocumentTab propsData={propsData} setActiveTab={setActiveTab} onRefresh={onRefresh} />}
      {activeTab === "invoice" && allow && isTabEnabled("invoice") && (<InvoiceTab propsData={propsData} setActiveTab={setActiveTab} />)}
      {activeTab === "visaStatus" && allow && propsData.paymentStatus === "Paid" && <VisaTab propsData={propsData} />}
    </div>
  )
}